import { ValueFormatterParams } from 'ag-grid-community';

/**
 * Formats a date or datetime value into a string based on the specified format.
 * @param value The date or datetime value to format.
 * @param format The format to use. Can be "datetime" or "date".
 * @returns A formatted string representation of the date or datetime value.
 */
export function formatDateTime(value: Date, format: 'datetime' | 'date'): string {
  if (format === 'datetime') {
    return value.toLocaleString();
  }

  return value.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
}

/**
 * Formats a given ISO date string to a datetime string.
 * @param params - The value formatter params.
 * @returns The formatted date string.
 */
export function isoDateTimeFormatter(
  params: ValueFormatterParams<string | number | undefined | null>
): string {
  if (params.value) {
    const isoDateStr = params.value;

    return formatDateTime(new Date(isoDateStr), 'datetime');
  }
  return '';
}

/**
 * Formats a given ISO date string to a date string.
 * @param params - The value formatter params.
 * @returns The formatted date string.
 */
export function isoDateFormatter(
  params: ValueFormatterParams<string | number | undefined | null>
): string {
  if (params.value) {
    const isoDateStr = params.value;
    return formatDateTime(new Date(isoDateStr), 'date');
  }
  return '';
}
